export enum Section {
    RBC = 'RBC',
    IRON = 'Iron',
    WBC = 'WBC',
    PLATELETS = 'Platelets',
    GLUCOSE = 'Glucose',
    KIDNEY = 'Kidney',
    NUTRIENTS = 'Nutrients',
    ELECTROLYTES = 'Electrolytes',
    PROTEINS = 'Proteins',
    LIVER_BILIARY = 'Liver / Biliary',
    LIPIDS = 'Lipids',
    INFLAMMATION_OXIDATIVE_STRESS = 'Inflammation / Oxidative Stress',
    THYROID = 'Thyroid',
    SEX_HORMONE = 'Hormones',
    STRESS_ADRENAL = 'Stress & Adrenal Balance',
    PROSTATE = 'Prostate',
    IMMUNE_INFLAMMATORY = 'Immune & Inflammatory Burden Index (I³)',
    ROOT_CAUSE_FRAMEWORK = 'Root Cause Framework',
    ABOVE_OPTIMAL = 'Above Optimal',
    BELOW_OPTIMAL = 'Below Optimal',
    NEEDS_ATTENTION = 'Alarm Range Markers',
    WORTH_DISCUSSING = 'Outside Lab Range Markers',
    FINE_TUNE = 'Outside Optimal Range Markers',
    MARKERS_OUTSIDE_OPTIMAL = 'Markers Outside Optimal',
    RESULTS_OVERVIEW = 'Results Overview',
    SUPPLEMENTS = 'Supplements',
    NOTES = 'Notes',
    // Pseudo-section holding the practitioner's edited override for the
    // consolidated "Section Notes" panel (each body-system section's own Notes
    // are gathered under this one panel near the report bottom, mirroring how
    // SUPPLEMENTS consolidates the per-section Supplements tabs).
    SECTION_NOTES = 'Section Notes',
    BMI = 'BMI'
}
